export type TenantStatus = "live" | "provisioning" | "suspended";

export interface Tenant {
  id: string;
  key: string;
  name: string;
  status: TenantStatus;
  region: string;
  inboundUrl: string;
  destinations: number;
  leads30d: number;
  failures: number;
  owner: string;
  ownerEmail: string;
  ownerEmailVerified: boolean;
  ownerSetupSentAt: string | null;
  createdAt: string;
  retentionDays: number;
  keyVersion: number;
}

export const statusMeta: Record<
  TenantStatus,
  { label: string; tone: "green" | "amber" | "neutral" }
> = {
  live: { label: "Live", tone: "green" },
  provisioning: { label: "Provisioning", tone: "amber" },
  suspended: { label: "Suspended", tone: "neutral" },
};
